import { render, staticRenderFns } from "./AppSettingsMenu.vue?vue&type=template&id=5c7f977e&scoped=true&"
import script from "./AppSettingsMenu.vue?vue&type=script&lang=ts&"
export * from "./AppSettingsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppSettingsMenu.vue?vue&type=style&index=0&id=5c7f977e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f977e",
  null
  
)

export default component.exports